import { LazyLoadImage } from 'react-lazy-load-image-component';

function Collection() {
return (
    <div style={{marginTop: "5em"}}>
    
    <h2 className="text-center">Collection</h2>
    <div className="container">
      <div className="text-center">
        <p className="normal centercontent">The 0xDRIP project is an A.I powered art collection on the Solana blockchain. Each artpiece is unique and generated from text parameters with our "DRIP" inspired style.</p>
        </div>
    </div>
    <div className="card-wrapper">
      <div className="card">
        <span className="title">0xDRIP</span>
        <LazyLoadImage
            alt="OG Collection"
            src="/OG.png" />
        <a className="about" href="https://howrare.is/0xdrip">howrare.is</a>
        <a className="icon-link me-icon" href="https://www.magiceden.io/marketplace/0xDrip"></a>

      </div>
      <div className="card">
        <span className="title">0xDRIP - Iceland </span>
        <LazyLoadImage
            alt="Iceland collection"
            src="/Iceland.jpg" />
        <a className="about" href="https://moonrank.app/collection/0xdrip_iceland">moonrank</a>
        <a className="icon-link me-icon" href="https://www.magiceden.io/marketplace/iceland_0xdrip"></a>

      </div>
      <div className="card">
        <span className="title">0xDRIP - Banners</span>
        
        <LazyLoadImage
            style={{marginBottom: "0.2em"}}
            alt="Banner #1"
            src="/Banner_1.jpg" />
        <LazyLoadImage
            style={{marginBottom: "0.2em"}}
            alt="Banner #2"
            src="/Banner_2.png" />
        <LazyLoadImage
            alt="Banner #3"
            src="/Banner_3.jpg" />
        <a className="about" href="https://moonrank.app/collection/0xdrip_banners">moonrank</a>
        <a className="icon-link me-icon" href="https://www.magiceden.io/marketplace/0xdrip_banners"></a>

      </div>
    </div>
    </div>
)
}
export default Collection